module.exports = __webpack_public_path__ + "static/media/desktop-form1.99e60580.png";